export enum LedgerPrinterModeEnum {
  All = 1,
  Total
}

export namespace LedgerPrinterModeEnum {
  export function values() {
    return Object.keys(LedgerPrinterModeEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

